import type { Personas } from '@festina-life/authentication'
import { useLocalStorage } from '@festina-life/ui/hooks'

export const usePersona = <T extends Personas>() =>
  useLocalStorage<T>('personaId')
